module.exports = __webpack_public_path__ + "img/v35_15.1492b7d1.gif";